import { useAssetId, useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import { SidebarStickyMenu, SummaryMenuItem, NotesMenuItem } from 'framework/ui/menu';

const AssetMenu = () => {
  const id = useAssetId();
  const { getTimelineUrl, getSingleEntityUrl } = useAssetUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} exact />
      <NotesMenuItem linkUrl={getTimelineUrl(id)} exact />
    </SidebarStickyMenu>
  );
};

export default AssetMenu;
